import React from "react";
import { Table } from "../../../../v2/design-system";
import { formatDateTime } from "../../../../utils/common";
import { HubNarrationCell } from "../societyHubShell";

const SubTransactionTable = ({ data, loading = false, pagination }) => {
  const columns = [
    {
      key: "createdAt",
      label: "Date",
      align: "left",
      render: (_, row) => formatDateTime(row?.createdAt),
    },
    {
      key: "transactionAmount",
      label: "Amount",
      render: (_, row) =>
        row?.transactionAmount !== undefined && row?.transactionAmount !== null ? `₹${row.transactionAmount}` : "",
    },
    { key: "txnMode", label: "Transaction Mode", align: "left" },
    { key: "voucherId", label: "Transaction Id", align: "left" },
    { key: "txnStatus", label: "Status", align: "left" },
    {
      key: "narration",
      label: "Narration",
      align: "left",
      render: (_, row) => <HubNarrationCell fullText={row?.narration} limit={30} />,
    },
  ];

  return (
    <Table
      data={data}
      columns={columns}
      rowKey="subTxnId"
      loading={loading}
      emptyMessage="No transactions for this settlement"
      pagination={pagination}
    />
  );
};

export default SubTransactionTable;
